import {
  initialSearchForm,
  IFlight,
  ISearchForm,
  ISearchPassengers,
} from "redux/searchForm";

/**
 * Shared
 */
import {
  IItinerary,
  IFareBreakdown,
  IPassengerTypeShort,
  ITravellerType,
  IFlightResult,
  dateObjToDateStringDotted,
  deepCloneObject,
  searchPassengerMapShort,
} from "@thekilroygroup/shared-ui";

export const buildSearchObjFromItinerary = (itinerary: IItinerary) => {
  let searchQuery: ISearchForm = deepCloneObject(initialSearchForm);

  const getPassengers = (itinerary: IItinerary) => {
    let passengers: ISearchPassengers = {
      adults: 0,
      children: 0,
      infants: 0,
    };

    itinerary.fareBreakdowns.forEach((fareBreakDown: IFareBreakdown) => {
      const passengersType = searchPassengerMapShort[
        fareBreakDown.passengerType as IPassengerTypeShort
      ] as ITravellerType;
      passengers[passengersType] += fareBreakDown.passengerQuantity;
    });
    return passengers;
  };

  const getFlights = (itinerary: IItinerary) => {
    let flights: IFlight[] = [];

    itinerary.flights.forEach((flightResult: IFlightResult) => {
      flights.push({
        departure: flightResult.departureAirport,
        arrival: flightResult.arrivalAirport,
        departureDate: dateObjToDateStringDotted(
          new Date(flightResult.departureDateTime.substring(0, 19)),
        ),
        validation: {
          arrival: { dirty: true, valid: true },
          departure: { dirty: true, valid: true },
          departureDate: { dirty: true, valid: true },
        },
      } as IFlight);
    });
    return flights;
  };

  const getTripType = (itinerary: IItinerary) => {
    if (itinerary.flights.length === 1) return "ONE_WAY";
    else if (itinerary.flights.length === 2) return "RETURN";
    else return "MULTI_DEST";
  };

  searchQuery["passengers"] = getPassengers(itinerary);
  searchQuery["cabinClass"] = itinerary.cabinClass;
  searchQuery["flights"] = getFlights(itinerary);
  searchQuery["tripType"] = getTripType(itinerary);

  return searchQuery;
};
